import type { DealLine } from '../../types/domain';
import { toNumber } from '../numbers';

// Régie horaire : mensuel = heures par mois × taux horaire (heures annuelles ramenées au mois).
// Aucun taux par défaut ; les heures en dépassement sont facturées hors application.
function hourlyMonthly(qte: unknown, unite: unknown, taux: unknown): number {
  const heures = toNumber(qte) || 0;
  const perMonth = unite === 'heures_an' ? heures / 12 : heures;
  return perMonth * (toNumber(taux) || 0);
}

export const hourlyEstimatedMonthly = (l: DealLine): number =>
  hourlyMonthly(l.heures_estime, l.heures_unite_estime, l.taux_horaire_estime);

export const hourlySoldMonthly = (l: DealLine): number =>
  hourlyMonthly(l.heures_vendu, l.heures_unite_vendu, l.taux_horaire_vendu);

// Heures vendues ramenées au mois (pour la phase créée à la conversion).
export const hourlySoldHoursPerMonth = (l: DealLine): number => {
  const h = toNumber(l.heures_vendu) || 0;
  return l.heures_unite_vendu === 'heures_an' ? h / 12 : h;
};
